import Seo from "@/components/Seo";
import { MaskedLine, FadeIn, Reveal } from "@/components/Reveal";

function LegalLayout({ eyebrow, title, children, testid }) {
  return (
    <div data-testid={testid}>
      <section className="pt-32 md:pt-44 pb-10 grain relative">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <FadeIn>
            <p className="eyebrow mb-5">{eyebrow}</p>
          </FadeIn>
          <h1 className="font-serif font-medium text-ink tracking-tight">
            <MaskedLine delay={0.1} className="text-4xl md:text-6xl">
              {title}
            </MaskedLine>
          </h1>
        </div>
      </section>
      <section className="pb-24 md:pb-36">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>{children}</Reveal>
        </div>
      </section>
    </div>
  );
}

const P = ({ children }) => (
  <p className="text-base leading-relaxed text-stone mb-5">{children}</p>
);
const H = ({ children }) => (
  <h2 className="font-serif text-2xl md:text-3xl text-ink mt-10 mb-4">{children}</h2>
);

export function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Laure Hila — Viaggia in Grande"
        description="Informativa sulla privacy del sito di Laure Hila — Viaggia in Grande."
      />
      <LegalLayout eyebrow="Legale" title="Privacy Policy" testid="privacy-page">
        <Pui>
          <P>
            Questa informativa descrive come vengono trattati i dati personali
            degli utenti che visitano questo sito, ai sensi del Regolamento (UE)
            2016/679 (GDPR).
          </P>
          <H>Titolare del trattamento</H>
          <P>
            Il titolare del trattamento è Laure Hila, Provincia di Bergamo, Italia.
            Per qualsiasi richiesta relativa alla privacy è possibile scrivere
            tramite il modulo contatti di questo sito.
          </P>
          <H>Dati raccolti</H>
          <P>
            Tramite il modulo contatti vengono raccolti nome, indirizzo email e
            contenuto del messaggio, utilizzati esclusivamente per rispondere alla
            richiesta dell'utente. Non vengono raccolti altri dati personali in
            modo attivo.
          </P>
          <H>Finalità e base giuridica</H>
          <P>
            I dati forniti volontariamente tramite il modulo sono trattati per
            rispondere alle richieste ricevute, sulla base del consenso
            dell'interessato espresso al momento dell'invio.
          </P>
          <H>Conservazione e diritti</H>
          <P>
            I dati sono conservati per il tempo necessario a gestire la richiesta.
            L'utente può in qualsiasi momento richiedere l'accesso, la rettifica o
            la cancellazione dei propri dati scrivendo tramite il modulo contatti.
          </P>
          <H>Servizi di terze parti</H>
          <P>
            Il sito contiene collegamenti a servizi esterni (Instagram, Facebook,
            LinkedIn, TikTok, WhatsApp, Amazon, Travel Advantage, MWR Life), che
            applicano le proprie informative privacy.
          </P>
        </Pui>
      </LegalLayout>
    </>
  );
}

export function CookiePolicy() {
  return (
    <>
      <Seo
        title="Cookie Policy | Laure Hila — Viaggia in Grande"
        description="Informativa sui cookie del sito di Laure Hila — Viaggia in Grande."
      />
      <LegalLayout eyebrow="Legale" title="Cookie Policy" testid="cookie-page">
        <Pui>
          <P>
            Questa pagina descrive l'utilizzo dei cookie e di tecnologie simili su
            questo sito.
          </P>
          <H>Cookie tecnici</H>
          <P>
            Il sito utilizza esclusivamente cookie tecnici e strumenti necessari al
            corretto funzionamento delle pagine e alla sicurezza del servizio.
            Questi cookie non richiedono il consenso dell'utente.
          </P>
          <H>Cookie di terze parti</H>
          <P>
            Il sito può includere contenuti o collegamenti di terze parti (video,
            social network, piattaforme esterne) che potrebbero installare cookie
            propri. Per maggiori informazioni si rimanda alle informative delle
            rispettive piattaforme.
          </P>
          <H>Gestione delle preferenze</H>
          <P>
            È possibile gestire o eliminare i cookie direttamente dalle
            impostazioni del proprio browser. La disattivazione dei cookie tecnici
            potrebbe compromettere alcune funzionalità del sito.
          </P>
        </Pui>
      </LegalLayout>
    </>
  );
}

const Pui = ({ children }) => <div>{children}</div>;
